import { WorkArrangements, EmploymentTypes, TestTypes } from '@talentmesh/utils';
import UIStrings from './UIStrings';

export function workArrangementToString(workArrangement: WorkArrangements): string {
    switch (workArrangement) {
        case 'Remote':
            return UIStrings.Remote;
        case 'OnLocation':
            return UIStrings.OnLocation;
        case 'Hybrid':
            return UIStrings.Hybrid;
        default:
            return '';
    }
}
export function employmentTypeToUIString(employmentType: EmploymentTypes): string {
    switch (employmentType) {
        case 'FullTime':
            return UIStrings.FullTime;
        case 'Permanent':
            return UIStrings.Permanent;
        case 'Contract':
            return UIStrings.Contract;
        case 'PartTime':
            return UIStrings.PartTime;
        case 'Temporary':
            return UIStrings.Temporary;
        case 'Internship':
            return UIStrings.Internship;
        default:
            return '';
    }
}

export function testToUIString(testType: TestTypes, jobFunctionName: string): string {
    switch (testType) {
        case 'Personality':
            return UIStrings.Personality;
        case 'Aptitude':
            return UIStrings.Aptitude;
        case 'Skills':
            return `${UIStrings.Skills} (${jobFunctionName})`;
        case 'EmotionalIntelligence':
            return UIStrings.EmotionalIntelligence;
        default:
            return '';
    }
}
